/* ============ Player profile: name + profanity check ============ */

const KEY = "carnival.name";

export function getName() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}

export function setName(name) {
  try { localStorage.setItem(KEY, name); } catch {}
}

/* Offensive-name filter. Normalizes leetspeak/spacing, then checks
   long tokens as substrings and short tokens as whole words. Deliberately
   strict — a false positive costs a retype, a false negative ends up
   engraved on the leaderboard. */
const LEET = { "0": "o", "1": "i", "3": "e", "4": "a", "5": "s", "7": "t", "8": "b", "@": "a", "$": "s", "!": "i", "+": "t" };

const BANNED_SUB = [ // substring match (long enough to be unambiguous)
  "fuck", "shit", "cunt", "bitch", "whore", "nigger", "nigga", "asshole",
  "retard", "hitler", "nazi", "penis", "vagina", "porno",
  "fisse", "kusse", "luder", "pikhoved", "roevhul", "neger", "perker",
  "boesseroev", "pedofil", "voldtaegt", "narrov", "kaelling",
];
const BANNED_WORD = [ // whole-word match (short words with innocent superstrings)
  "pik", "lort", "sex", "fag", "hoe", "ass", "dick", "cock", "slut", "anus",
  "tisse", "bolle",
];

const normalize = (s) =>
  s.toLowerCase()
    .replace(/[015347８8@$!+]/g, (c) => LEET[c] || c)
    .replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa")
    .replace(/[^a-z]/g, "");

const words = (s) =>
  s.toLowerCase()
    .replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa")
    .split(/[^a-z0-9]+/).filter(Boolean)
    .map((w) => w.replace(/[0-9]/g, (c) => LEET[c] || c));

/* Returns "" if ok, else an error key for i18n. */
export function validateName(raw) {
  const name = (raw || "").trim();
  if (name.length < 2 || name.length > 12) return "name_err_len";
  const flat = normalize(name);
  for (const b of BANNED_SUB) if (flat.includes(b)) return "name_err_rude";
  const ws = words(name);
  for (const b of BANNED_WORD) if (ws.includes(b) || flat === b) return "name_err_rude";
  return "";
}
